import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/timeline/timeline.component.js'

const tagName = 'dap-ds-timeline'

/**
 * `dap-ds-timeline`
 * @summary A timeline is a graphical representation of a series of events.
 * @element dap-ds-timeline
 * @title - Timeline
 *
 * @slot - The default slot for the timeline items.
 *
 * @csspart base - The main timeline container.
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSTimeline',
})

export default reactWrapper
